import { render } from "./LegRow.vue?vue&type=template&id=253f7091"
import script from "./LegRow.vue?vue&type=script&lang=js"
export * from "./LegRow.vue?vue&type=script&lang=js"

import "./LegRow.vue?vue&type=style&index=0&id=253f7091&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__